import { useTranslate } from "@similarweb/i18n-provider";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import { NoDataBanner } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/NoDataBanner/NoDataBanner";
import SignalEventListTracked from "app/pages/sales-intelligence/pages/company-analysis/containers/signals/SignalEventList/SignalEventListTracked";
import SignalEventManagementContainer from "app/pages/sales-intelligence/pages/company-analysis/containers/signals/SignalEventManagementContainer/SignalEventManagementContainer";

const SignalsSectionRoot = () => {
    const { translate } = useTranslate();

    return (
        <ErrorBoundaryWithLogging
            fallback={
                <Card
                    isEmpty
                    dataAutomation="signals-tab"
                    renderContent={() => (
                        <NoDataBanner
                            data-automation="signal-events-empty-content"
                            text={translate("si.account-overview.signals.no-signals")}
                        />
                    )}
                />
            }
        >
            <SignalEventManagementContainer />
            <Card
                dataAutomation="signals-tab"
                renderContent={() => <SignalEventListTracked title={translate("si.account-overview.tab.signals")} />}
            />
        </ErrorBoundaryWithLogging>
    );
};

export default SignalsSectionRoot;
